
import { RevPopover } from '@ds/components/Popover'
import { RevTooltip } from '@ds/components/Tooltip'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import productTranslations from '@product/pages/product.translations'

import translations from '../AddToCart/AddToCart.translations'

import AnimatedPrice from './AnimatedPrice/AnimatedPrice.vue'

export default {
  components: {
    RevPopover,
    RevTooltip,
    AnimatedPrice,
  },
  props: {
    price: {
      type: Object,
      required: true,
    },
    priceColor: {
      type: String,
      default: null,
    },
    priceLabel: {
      type: String,
      default: null,
    },
    priceEmphasis: {
      type: String,
      default: null,
    },
    originalPrice: {
      type: Object,
      default: () => ({}),
    },
    isVatIncluded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      breakpoint: 'breakpoint',
    }),
    isMobile() {
      return this.breakpoint < 2
    },
    translations: () => translations,
    productTranslations: () => productTranslations,

    originalPriceDisplay() {
      return this.$t(translations.originalPriceDisplay, {
        price: this.$t.price(this.originalPrice),
      })
    },

    shouldDisplayOriginalPrice() {
      return !isEmpty(this.originalPrice)
    },
  },
}
